import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from "reactstrap";
import ConvertToMoney from "./convert-to-money";

const propTypes = {
  display: PropTypes.bool.isRequired,
  toggleDisplay: PropTypes.func.isRequired,
  receiptData: PropTypes.shape({
    campaign_id: PropTypes.number,
    card_info: PropTypes.string,
    country_iso: PropTypes.string,
    coupon_amount: PropTypes.number,
    coupon_count: PropTypes.number,
    date: PropTypes.string,
    email: PropTypes.string,
    full_name: PropTypes.string,
    payment_amount: PropTypes.number,
    reference_number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    site_credit: PropTypes.number,
    time: PropTypes.string,
    total: PropTypes.number,
    upgrade: PropTypes.bool,
    upgrade_payment: PropTypes.number
  }),
  showNotification: PropTypes.bool
};

const ReceiptModal = ({ display, toggleDisplay, receiptData = {}, showNotification = false }) => {
  const campaignCost =
    receiptData.payment_amount +
    (receiptData.site_credit && receiptData.site_credit > 0 ? receiptData.site_credit : 0);
  return (
    <Modal
      isOpen={display}
      toggle={toggleDisplay}
      fade={false}
      size="lg"
      className="account-app receipt-modal"
    >
      <ModalHeader toggle={toggleDisplay} className="pb-0">
        <span className="mr-3">Receipt - Campaign #{receiptData.campaign_id}</span>
      </ModalHeader>
      <ModalBody className="pt-0">
        {showNotification && (
          <Row>
            <Col>You will also be mailed a purchase receipt.</Col>
          </Row>
        )}
        <hr />
        <Row>
          <Col>{receiptData.full_name}</Col>
        </Row>
        <Row>
          <Col>{receiptData.email}</Col>
        </Row>
        <hr />
        {receiptData.reference_number && (
          <Row className="my-2">
            <Col xs="5" className="text-right">
              Reference:
            </Col>
            <Col xs="7">{receiptData.reference_number}</Col>
          </Row>
        )}
        {receiptData.upgrade ? (
          <Row className="my-2">
            <Col xs="5" className="text-right">
              Upgrade Cost:
            </Col>
            <ConvertToMoney
              number={receiptData.upgrade_payment}
              countryIso={receiptData.country_iso}
              className="col-7"
            />
          </Row>
        ) : (
          <Row className="my-2">
            <Col xs="5" className="text-right">
              Campaign Cost:
            </Col>
            <ConvertToMoney
              number={campaignCost}
              countryIso={receiptData.country_iso}
              className="col-7"
            />
          </Row>
        )}

        {receiptData.coupon_amount && receiptData.coupon_amount > 0 && !receiptData.upgrade ? (
          <Row className="my-2">
            <Col xs="5" className="text-right">
              Coupon
              {receiptData.coupon_count === 1 ? "" : "s"}:
            </Col>
            <ConvertToMoney
              number={-receiptData.coupon_amount}
              countryIso={receiptData.country_iso}
              className="col-7"
            />
          </Row>
        ) : (
          ""
        )}
        {receiptData.site_credit && receiptData.site_credit > 0 && !receiptData.upgrade ? (
          <Row className="my-2">
            <Col xs="5" className="text-right">
              Account balance:
            </Col>
            <ConvertToMoney
              number={-receiptData.site_credit}
              countryIso={receiptData.country_iso}
              className="col-7"
            />
          </Row>
        ) : (
          ""
        )}
        {receiptData.total !== undefined && receiptData.total >= 0 ? (
          <Row className="my-2">
            <Col xs="5" className="text-right">
              Total:
            </Col>
            <ConvertToMoney
              number={receiptData.upgrade ? receiptData.upgrade_payment : receiptData.total}
              countryIso={receiptData.country_iso}
              className="col-7"
            />
          </Row>
        ) : (
          ""
        )}

        {receiptData.date && receiptData.date.length > 0 ? (
          <Row className="my-2">
            <Col xs="5" className="text-right">
              Date:
            </Col>
            <Col xs="7">{receiptData.date}</Col>
          </Row>
        ) : (
          ""
        )}
        {receiptData.time && receiptData.time.length > 0 ? (
          <Row className="my-2">
            <Col xs="5" className="text-right">
              Time:
            </Col>
            <Col xs="7">{receiptData.time}</Col>
          </Row>
        ) : (
          ""
        )}

        {receiptData.card_info && receiptData.card_info.length > 0 ? (
          <Row className="my-2">
            <Col xs="5" className="text-right">
              Card:
            </Col>
            <Col xs="7">{receiptData.card_info}</Col>
          </Row>
        ) : (
          ""
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggleDisplay} className="btn-sharp">
          OK
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ReceiptModal.propTypes = propTypes;

export default ReceiptModal;
